module.exports = __webpack_public_path__ + "img/eliminar.e6423213.svg";